// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".claims-compare{min-height:calc(100vh - 300px)}.claims-compare .identical{margin:1em 0;text-align:center;color:#616161}.claims-compare pre{margin:0;color:#061632;white-space:pre-wrap;font-family:inherit;font-size:inherit}.claims-compare pre .c-added{color:#1c8c03}.claims-compare pre .c-removed{color:#d11932;text-decoration:line-through}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
